import { ClbIcon } from '@celebration/react/ClbIcon/ClbIcon';
import { Icons } from '@celebration/react/ClbIcon/props.types';
import { useTranslation } from 'react-i18next';
import { ReactComponent as MapPinIcon } from '../../assets/svg/load-card/map-pin.svg';
import { ReactComponent as TruckIcon } from '../../assets/svg/load-card/truck.svg';
import './icon-info.scss';

interface IconInfoProps {
    icon: Icons | 'map-pin-icon' | 'truck-icon';
    title: string;
    info?: string;
}

function IconInfo({ icon, title, info }: Readonly<IconInfoProps>) {
    const { t } = useTranslation();

    const isClbIcon = icon !== 'map-pin-icon' && icon !== 'truck-icon';
    const isMapPinIcon = icon === 'map-pin-icon';
    const isTruckIcon = icon === 'truck-icon';
    const isWhitespaceString = (str: string) => !str.replace(/\s/g, '').length;

    return (
        <div className="load-details-icon-info">
            <div className="load-details-icon-info__icon__title">
                {isClbIcon && (
                    <ClbIcon
                        icon={icon}
                        size="sm"
                        data-testid="icon-info-clb-icon"
                    />
                )}
                {isMapPinIcon && (
                    <MapPinIcon data-testid="icon-info-map-icon" />
                )}
                {isTruckIcon && (
                    <TruckIcon data-testid="icon-info-truck-icon" />
                )}
                <span className="load-details-icon-info__title">
                    {t(title)}
                </span>
            </div>
            <span className="load-details-icon-info__info">
                {info && !isWhitespaceString(info) ? info : '---'}
            </span>
        </div>
    );
}

export default IconInfo;
